<script>

import DeckStyles from './decks'
import BackStyles from './backs'

export default {

  props: {
    theme: {
      style: String,
      required: true
    },

    backTheme: {
      style: String,
      default: 'work'
    },

  },

  data() {
    return {
      selectedCard: null,
      reveal: false
    }
  },

  computed: {
    deck() {
      return DeckStyles[this.theme]
    },
    cards() {
      return this.deck.cards
    },
    backImage() {
      return BackStyles[this.backTheme]
    }
  },

  watch: {
    selectedCard() {
      this.$emit('select', this.selectedCard)
      if (!this.selectedCard) {
        this.reveal = false
      }
    }
  }

}
</script>

<template>
  <div class="deck">
    <transition name="opacity">
      <div class="fullscreen" v-if="selectedCard && (reveal || !backImage)" @click="selectedCard = null">
        <img :src="selectedCard.path"/>
      </div>
      <div class="fullscreen" v-else-if="selectedCard" @click="reveal = true">
        <img :src="backImage.image"/>
      </div>
    </transition>

    <transition name="opacity">
      <ul class="deck" v-if="!selectedCard">
        <li
          v-for="card in cards"
          :key="card.name"
          @click="selectedCard = card"
          class="card"
        >
          <img :src="card.path"/>
        </li>
      </ul>
    </transition>
  </div>
</template>

<style lang="scss">
body.dark div.deck {

  li img {
    box-shadow: 0 0 10px #000;
  }

  img {
    background: black;
    opacity: 0.8;
    border: 8px solid #444;
  }

  .fullscreen img {
    box-shadow: 0 0 15px #000;
  }
}
div.deck {
  ul {
    padding: 0;
    margin: 0;
    float: left;
    width: 100vw;
    height: 100vh;
    padding-top: 40px;
  }
  li {
    list-style-type: none;
    float: left;
    overflow: hidden;
    text-align: center;
    box-sizing: border-box;

    padding: 10px;

    &.card {
      width: 16.6%;
      margin-top: 4px;
      margin-bottom: 9px;
    }

    img {
      box-shadow: 0 0 10px #bbb;
      user-select: none;
    }
  }

  .fullscreen {
    position: fixed;
    width: 100%;
    height: 100%;
    img {
      box-shadow: 0 0 15px #666;
      max-width: 90%;
      max-height: 90%;
      border-radius: 30px;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
  }


  @media (max-width: 1200px) {
    li.card { width: 20%; }
  }
  @media (max-width: 800px) {
    li.card { width: 33%; }
  }
  @media (max-width: 400px) {
    li.card { width: 50%; }
    li img {
      box-shadow: 0 0 7px #bbb !important;
    }
  }

  img {
    max-width: 100%;
    max-height: 100%;
    display: inline-block;
    border: 8px solid white;
    border-radius: 15px;
    box-sizing: border-box;
  }

  .opacity-enter-active, .opacity-leave-active {
    transition: all .3s ease;
    transform: translateZ(0);
    backface-visibility: hidden;
  }

  .opacity-enter, .opacity-leave-to {
    opacity: 0;
  }
}
</style>